export const TOKEN_TYPE = 'Bearer'
export const CLIENT_TYPE = 'Basic'
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
